import { put, call, take, fork } from 'redux-saga/effects'
import { AICreatorGetAttachmentTitlesService } from 'src/api/ai-creator'
import { GET_ATTACHMENT_TITLES } from '../../reducers/ai-creator/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* getAttachmentTitlesFlow(payload) {
  try {
    const { attachmentIds, callback } = payload

    const response = yield call(
      AICreatorGetAttachmentTitlesService,
      attachmentIds,
    )
    callback(response)

    yield put(operationSuccess())
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* getAttachmentTitlesWatcher() {
  while (true) {
    const action = yield take(GET_ATTACHMENT_TITLES)
    const { payload } = action

    yield fork(generalSaga, getAttachmentTitlesFlow, payload)
  }
}
